import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { SessionService } from '@app/core/services';


@Injectable({
  providedIn: 'root',
})
export class TermsGuard  {

  constructor(
    private _router: Router,
    private _sessionService: SessionService,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (
      this._sessionService.termsApproval?.isParentTermsRequired ||
      this._sessionService.termsApproval?.isOrganizationTermsRequired ||
      this._sessionService.termsApproval?.isCadPadRequired ||
      this._sessionService.termsApproval?.isUsdPadRequired
    ) {
      const redirect = state.url;

      return this._router.createUrlTree(['/terms'], { queryParams: { redirect } });
    }

    return true;
  }

}
